import {BaseEntity} from '../../app-common/data/BaseEntity';
import {IFlaggable} from '../../flag/interfaces/iFlaggable';
import {JobStatus} from './jobStatus';
import {FlagColor} from '../../flag/data/flagColor';

export class Job extends BaseEntity<number> implements IFlaggable {
  parentId?: number;
  status: JobStatus;
  title: string;
  description: string;
  assigneeId?: string;
  customerId?: number;
  priority: number;
  lexoRank: string;
  flagged: boolean;
  flagColor: FlagColor;
  dueDate?: Date;
  progress: number;
}
